import { React, useAPI } from 'mcelroy-lib'
import { TablePage } from 'mcelroy-components'

/*
    Page to list users
    Have to be type of administrator
    Distributor admins can only see users in their account
*/
export function UsersPage() {
    // API user list query
    const { loading, data } = useAPI(`
    query{
        users{
            id
            firstName
            lastName
            email
            customerNbr
            permissions{ employee vendor customer consumer, customerOverride, custadmin}
            vendorNumber
          }
    }
    `)

    // Table columns
    const columns = [
        { title: 'First', name: 'firstName' },
        { title: 'Last', name: 'lastName' },
        { title: 'Email', name: 'email' },
        { title: 'Type', name: 'type' },
        { title: 'Account', name: 'customerNbr' }
    ]

    if (data?.users) {
        for (const u of data?.users) {
            if (u.permissions?.employee) {
                u.type = 'Employee'
                if (u.permissions?.employee && u.permissions?.customerOverride != null)
                    u.customerNbr = u.permissions.customerOverride
            } else if( u.permissions.customer){
                u.type = 'Distributor'
                if (u.permissions.custadmin)
                    u.type = 'Distributor Admin'
            } else if (u.permissions.vendor) {
                u.type = 'Vendor'
                u.customerNbr = u.vendorNumber
            } else {
                u.type = 'Consumer'
                u.customerNbr = ''
            }
        }
    }

    // Page display
    return (
        <TablePage columns={columns} data={data?.users} loading={loading}
            options={{
                keyColumn: 'id',
                limit: 100,
                rowClickTo: '/users/:id'
            }}
            actions={[{ label: 'Create User', to: '/create' }]}
        />
    )
}
